import React from 'react'
import {Button, Col, Row, Tag, Typography} from "antd";
import {ClearOutlined, ExpandOutlined, FilterFilled,} from "@ant-design/icons";
import ColorFilter from "../base/filters/ColorFilter";
import InStockFilter from "../base/filters/InStockFilter";
import CollectionFilter from "../base/filters/CollectionFilter";
import BusinessTypeFilter from "../base/filters/BusinessTypeFilter";
import SubjectFilter from "../base/filters/SubjectFilter";
import StyleFilter from "../base/filters/StyleFilter";
import MediumFilter from "../base/filters/MediumFilter";
import SizeRangeFilter from "../base/filters/SizeRangeFilter";
import PriceRangeFilter from "../base/filters/PriceRangeFilter";
import CreateYearFilter from "../base/filters/CreateYearFilter";
import ExpandableFilterLayout from "../ExpandableFilterLayout";

const {Title, Text} = Typography

class ArtworkFiltersPanel extends React.Component {
    constructor(props) {
        super(props)
        this.prefix = props.name
        let filters = this.loadJsonCache('filters' + this.props.artistId) ?? {}

        this.state = {
            ...filters
        }
    }

    loadJsonCache(key) {
        try {
            let string = localStorage.getItem(this.prefix + '_' + key)
            return JSON.parse(string)
        } catch (e) {
            return {}
        }
    }

    updateData = () => {
        if (this.props.updateData)
            this.props.updateData({
                ...this.state
            })
        if (this.props.onChange) {
            this.props.onChange({
                ...this.state
            })
        }
    }

    render() {
        return (
            <>
                <ExpandableFilterLayout>
                    <Col>
                        <CreateYearFilter onChange={(filter) => {
                            this.setState({
                                ...this.state,
                                ...filter
                            }, this.updateData)
                        }}/>
                    </Col>
                    <Col>
                        <PriceRangeFilter onChange={(filter) => {
                            this.setState({
                                ...this.state,
                                ...filter
                            }, this.updateData)
                        }}/>
                    </Col>
                    <Col>
                        <SizeRangeFilter onChange={(filter) => {
                            this.setState({
                                ...this.state,
                                ...filter
                            }, this.updateData)
                        }}/>
                    </Col>
                    <Col>
                        <MediumFilter onChange={(filter) => {
                            this.setState({
                                ...this.state,
                                ...filter
                            }, this.updateData)
                        }}/>
                    </Col>
                    <Col>
                        <StyleFilter onChange={(filter) => {
                            this.setState({
                                ...this.state,
                                ...filter
                            }, this.updateData)
                        }}/>
                    </Col>
                    <Col>
                        <SubjectFilter onChange={(filter) => {
                            this.setState({
                                ...this.state,
                                ...filter
                            }, this.updateData)
                        }}/>
                    </Col>
                    <Col>
                        <BusinessTypeFilter onChange={(filter) => {
                            this.setState({
                                ...this.state,
                                ...filter
                            }, this.updateData)
                        }}/>
                    </Col>
                    <Col>
                        <ColorFilter onChange={(filter) => {
                            this.setState({
                                ...this.state,
                                ...filter
                            }, this.updateData)
                        }}/>
                    </Col>
                    <Col>
                        <CollectionFilter artistId={this.props.artistId} onChange={(filter) => {
                            this.setState({
                                ...this.state,
                                ...filter
                            }, this.updateData)
                        }}/>
                    </Col>
                    <Col>
                        <InStockFilter onChange={(filter) => {
                            this.setState({
                                ...this.state,
                                ...filter
                            }, this.updateData)
                        }}/>
                    </Col>
                </ExpandableFilterLayout>
                {(this.state.search ||
                    this.state.startDateFilter ||
                    this.state.endDateFilter ||
                    this.state.maxPriceFilter ||
                    this.state.minPriceFilter ||
                    this.state.minSizeHFilter ||
                    this.state.minSizeWFilter ||
                    this.state.maxSizeHFilter ||
                    this.state.maxSizeWFilter ||
                    this.state.mediumFilter ||
                    this.state.styleFilter ||
                    this.state.maxSizeFilter ||
                    this.state.minSizeFilter ||
                    this.state.subjectFilter ||
                    this.state.usedTypeFilter ||
                    this.state.colorFilter ||
                    this.state.collectionFilter ||
                    this.state.inStockFilter) && (
                    <Row align='middle' gutter={{xs: 8, sm: 16, md: 24}} style={{marginTop: 6}}>
                        <Col span={24}>
                            <Title level={5} style={{marginBottom: 0}}>
                                <ExpandOutlined style={{width: 20, height: 20}}/> Active Filters
                            </Title>
                        </Col>
                        <Col span={24} style={{padding: 6, marginLeft: 6}}>
                            {this.state.search && (
                                <Tag
                                    closable
                                    onClose={() => {
                                        this.setState(
                                            {
                                                search: null
                                            },
                                            this.updateData
                                        )
                                    }}
                                >
                                    Search for &quot;{this.state.search}&quot;
                                </Tag>
                            )}
                            {this.state.startDateFilter && (
                                <Tag
                                    closable
                                    onClose={() => {
                                        this.setState(
                                            {
                                                startDateFilter: null
                                            },
                                            this.updateData
                                        )
                                    }}
                                >
                                    {this.state.startDateFilter.text} &quot;{this.state.startDateFilter.value}&quot;
                                </Tag>
                            )}
                            {this.state.endDateFilter && (
                                <Tag
                                    closable
                                    onClose={() => {
                                        this.setState(
                                            {
                                                endDateFilter: null
                                            },
                                            this.updateData
                                        )
                                    }}
                                >
                                    {this.state.endDateFilter.text} &quot;{this.state.endDateFilter.value}&quot;
                                </Tag>
                            )}
                            {this.state.minPriceFilter && (
                                <Tag
                                    closable
                                    onClose={() => {
                                        this.setState(
                                            {
                                                minPriceFilter: null
                                            },
                                            this.updateData
                                        )
                                    }}
                                >
                                    {this.state.minPriceFilter.text} &quot;{this.state.minPriceFilter.value}&quot;
                                </Tag>
                            )}
                            {this.state.maxPriceFilter && (
                                <Tag
                                    closable
                                    onClose={() => {
                                        this.setState(
                                            {
                                                maxPriceFilter: null
                                            },
                                            this.updateData
                                        )
                                    }}
                                >
                                    {this.state.maxPriceFilter.text} &quot;{this.state.maxPriceFilter.value}&quot;
                                </Tag>
                            )}

                            {this.state.maxSizeWFilter && (
                                <Tag
                                    closable
                                    onClose={() => {
                                        this.setState(
                                            {
                                                maxSizeWFilter: null
                                            },
                                            this.updateData
                                        )
                                    }}
                                >
                                    {this.state.maxSizeWFilter.text} &quot;{this.state.maxSizeWFilter.value}&quot;
                                </Tag>
                            )}
                            {this.state.minSizeWFilter && (
                                <Tag
                                    closable
                                    onClose={() => {
                                        this.setState(
                                            {
                                                minSizeWFilter: null
                                            },
                                            this.updateData
                                        )
                                    }}
                                >
                                    {this.state.minSizeWFilter.text} &quot;{this.state.minSizeWFilter.value}&quot;
                                </Tag>
                            )}
                            {this.state.maxSizeHFilter && (
                                <Tag
                                    closable
                                    onClose={() => {
                                        this.setState(
                                            {
                                                maxSizeHFilter: null
                                            },
                                            this.updateData
                                        )
                                    }}
                                >
                                    {this.state.maxSizeHFilter.text} &quot;{this.state.maxSizeHFilter.value}&quot;
                                </Tag>
                            )}
                            {this.state.minSizeHFilter && (
                                <Tag
                                    closable
                                    onClose={() => {
                                        this.setState(
                                            {
                                                minSizeHFilter: null
                                            },
                                            this.updateData
                                        )
                                    }}
                                >
                                    {this.state.minSizeHFilter.text} &quot;{this.state.minSizeHFilter.value}&quot;
                                </Tag>
                            )}

                            {this.state.mediumFilter && this.state.mediumFilter.value?.map((v, index) => (
                                <Tag
                                    key={"medium" + index}
                                    closable
                                    onClose={() => {
                                        this.setState(
                                            {
                                                mediumFilter: {
                                                    text: this.state.mediumFilter.text,
                                                    value: this.state.mediumFilter.value.filter((item) => item !== v)
                                                }
                                            },
                                            this.updateData
                                        )
                                    }}
                                >
                                    {this.state.mediumFilter.text} &quot;{v}&quot;
                                </Tag>
                            ))}

                            {this.state.styleFilter && this.state.styleFilter.value?.map((v, index) => (
                                <Tag
                                    key={"style" + index}
                                    closable
                                    onClose={() => {
                                        this.setState(
                                            {
                                                styleFilter: {
                                                    text: this.state.styleFilter.text,
                                                    value: this.state.styleFilter.value.filter((item) => item !== v)
                                                }
                                            },
                                            this.updateData
                                        )
                                    }}
                                >
                                    {this.state.styleFilter.text} &quot;{v}&quot;
                                </Tag>
                            ))}

                            {this.state.maxSizeFilter && (
                                <Tag
                                    closable
                                    onClose={() => {
                                        this.setState(
                                            {
                                                maxSizeFilter: null
                                            },
                                            this.updateData
                                        )
                                    }}
                                >
                                    {this.state.maxSizeFilter.text} &quot;{this.state.maxSizeFilter.value}&quot;
                                </Tag>
                            )}
                            {this.state.minSizeFilter && (
                                <Tag
                                    closable
                                    onClose={() => {
                                        this.setState(
                                            {
                                                minSizeFilter: null
                                            },
                                            this.updateData
                                        )
                                    }}
                                >
                                    {this.state.minSizeFilter.text} &quot;{this.state.minSizeFilter.value}&quot;
                                </Tag>
                            )}
                            {this.state.subjectFilter && this.state.subjectFilter.value?.map((v, index) => (
                                <Tag
                                    key={"subject" + index}
                                    closable
                                    onClose={() => {
                                        this.setState(
                                            {
                                                subjectFilter: {
                                                    text: this.state.subjectFilter.text,
                                                    value: this.state.subjectFilter.value.filter((item) => item !== v)
                                                }
                                            },
                                            this.updateData
                                        )
                                    }}
                                >
                                    {this.state.subjectFilter.text} &quot;{v}&quot;
                                </Tag>
                            ))}
                            {this.state.usedTypeFilter && this.state.usedTypeFilter.value?.map((v, index) => (
                                <Tag
                                    key={index}
                                    closable
                                    onClose={() => {
                                        this.setState(
                                            {
                                                usedTypeFilter: {
                                                    text: this.state.usedTypeFilter.text,
                                                    value: this.state.usedTypeFilter.value.filter((item) => item !== v)
                                                }
                                            },
                                            this.updateData
                                        )
                                    }}
                                >
                                    {this.state.usedTypeFilter.text} &quot;{v}&quot;
                                </Tag>
                            ))}

                            {this.state.colorFilter && this.state.colorFilter.value?.map((v, index) => (
                                <Tag
                                    key={index}
                                    closable
                                    style={{color: '#' + v}}
                                    onClose={() => {
                                        this.setState(
                                            {
                                                colorFilter: this.state.colorFilter.filter((item) => item !== v)
                                            },
                                            this.updateData
                                        )
                                    }}
                                >
                                    {this.state.colorFilter.text} &quot;{v}&quot;
                                </Tag>
                            ))}
                            {this.state.collectionFilter && (
                                <Tag
                                    closable
                                    onClose={() => {
                                        this.setState(
                                            {
                                                collectionFilter: null
                                            },
                                            this.updateData
                                        )
                                    }}
                                >
                                    {this.state.collectionFilter.text}: &quot;{this.state.collectionFilter.value}&quot;
                                </Tag>
                            )}
                            {this.state.inStockFilter && (
                                <Tag
                                    closable
                                    onClose={() => {
                                        this.setState(
                                            {
                                                inStockFilter: null
                                            },
                                            this.updateData
                                        )
                                    }}
                                >
                                    {this.state.inStockFilter.text} &quot;{this.state.inStockFilter.value}&quot;
                                </Tag>
                            )}
                            <Button
                                icon={<ClearOutlined/>}
                                type='link'
                                style={{padding: 0, marginLeft: 6, marginTop: 12}}
                                onClick={() => {
                                    this.setState(
                                        {
                                            search: null,
                                            startDateFilter: null,
                                            endDateFilter: null,
                                            maxPriceFilter: null,
                                            minPriceFilter: null,
                                            minSizeHFilter: null,
                                            maxSizeHFilter: null,
                                            minSizeWFilter: null,
                                            maxSizeWFilter: null,
                                            mediumFilter: null,
                                            styleFilter: null,
                                            maxSizeFilter: null,
                                            minSizeFilter: null,
                                            subjectFilter: null,
                                            usedTypeFilter: null,
                                            colorFilter: null,
                                            collectionFilter: null,
                                            inStockFilter: null
                                        },
                                        this.updateData
                                    )
                                }}
                            >
                                Clear All Filters
                            </Button>
                        </Col>
                    </Row>
                )}
            </>
        )
    }
}

export default ArtworkFiltersPanel